import { render, staticRenderFns } from "./addProjectBomFromInherit.vue?vue&type=template&id=4e9142aa&scoped=true&"
import script from "./addProjectBomFromInherit.vue?vue&type=script&lang=js&"
export * from "./addProjectBomFromInherit.vue?vue&type=script&lang=js&"
import style0 from "./addProjectBomFromInherit.vue?vue&type=style&index=0&id=4e9142aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9142aa",
  null
  
)

export default component.exports